import { useModalContext } from "@/context/ModalContext";
import ModalWrapper from "../ModalWrapper/ModalWrapper";
import styles from "./AppReviewFlowModal.module.css";
import { Mixpanel } from "@/helpers/mixpanel";
import { FeedbackScoreBar } from "@/components/results/personalityAnalysis/AnalysisFeedback/AnalysisFeedback";
import { useEffect, useState } from "react";

export default function AppReviewFlowModal(props: { onFinish: () => void }) {
  const { setModalOpen } = useModalContext();

  const [feedback, setFeedback] = useState<number | null>(null);

  useEffect(() => {
    Mixpanel?.track("App Feedback Prompt Seen", {}, "d");
  }, []);

  return (
    <ModalWrapper
      onClose={() => props.onFinish()}
      backgroundColor="#2D2927"
      noLine
      title=""
    >
      <div className={styles.main}>
        <div className={styles.wrapper}>
          <h4 className={styles.title}>How are you liking Dimensional?</h4>
          <h5 className={styles.subtitle}>Feedback helps us improve</h5>
          <div className={styles.emojiParentDiv}>
            <div
              onClick={() => {
                Mixpanel?.track("App Feedback Submitted", { Score: 0 }, "d");
                setFeedback(0);
                setTimeout(() => {
                  setModalOpen(false);
                  props.onFinish();
                }, 500);
              }}
              className={
                feedback === 0 ? styles.emojiBoxSelected : styles.emojiBox
              }
            >
              <p className={styles.emoji}>😒</p>
              <p className={styles.desc}>Meh</p>
              <FeedbackScoreBar score={0} />
            </div>
            <div
              onClick={() => {
                Mixpanel?.track("App Feedback Submitted", { Score: 1 }, "d");
                setFeedback(1);
                setTimeout(() => {
                  setModalOpen(false);
                  props.onFinish();
                }, 500);
              }}
              className={
                feedback === 1 ? styles.emojiBoxSelected : styles.emojiBox
              }
            >
              <p className={styles.emoji}>🙂</p>
              <p className={styles.desc}>{"It's okay"}</p>
              <FeedbackScoreBar score={1} />
            </div>
            <div
              onClick={() => {
                Mixpanel?.track("App Feedback Submitted", { Score: 1 }, "d");
                setFeedback(2);
                setTimeout(() => {
                  setModalOpen(false);
                  props.onFinish();
                }, 500);
              }}
              className={
                feedback === 2 ? styles.emojiBoxSelected : styles.emojiBox
              }
            >
              <p className={styles.emoji}>😊</p>
              <p className={styles.desc}>Like it</p>
              <FeedbackScoreBar score={2} />
            </div>
            <div
              onClick={() => {
                Mixpanel?.track("App Feedback Submitted", { Score: 2 }, "d");
                if (window.Android) {
                  window.Android.triggerInAppReview();
                }
                setFeedback(3);
                setTimeout(() => {
                  setModalOpen(false);
                  props.onFinish();
                }, 500);
              }}
              className={
                feedback === 3 ? styles.emojiBoxSelected : styles.emojiBox
              }
            >
              <p className={styles.emoji}>😍</p>
              <p className={styles.desc}>Love it</p>
              <FeedbackScoreBar score={3} />
            </div>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
}
